<template>
    <td-dialog :title="title" :before-close="extendDialogClose" :visible.sync="dialogExtendVisible" width="335px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formExtendInfo" ref="formExtendInfo" label-position="right" :label-width="formLabelWidth" :rules="rules">
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('common.EXTENDNAME')" prop="sName">
                        <td-input v-model="formExtendInfo.sName" :maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('extendCommon.VIEWNAME')">
                        <td-input v-model="formExtendInfo.sViewName" :maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('extendCommon.ELEMENT_FlG')" prop="sElementFlg">
                        <td-input v-model="formExtendInfo.sElementFlg" :maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('common.EXTENDTYPE')" prop="sElementType">
                        <td-select
                            v-model="formExtendInfo.sElementType"
                            :placeholder="$t('common.PLEASE_SELECT')"
                            @change="
                                val => {
                                    handleSelectChange(val);
                                }
                            "
                            :options="this.extendTypes"
                            keys="sElementType"
                            text="sElementType"
                            :clearable="false"
                        >
                        </td-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-show="showParamsText">
                <el-form-item :label="$t('common.EXTENDDATA')"><td-radio v-model="radio" :options="optionsRadio"></td-radio></el-form-item>
                <el-form-item prop="sOptionData">
                    <td-input v-show="!radio" type="textarea" v-model="formExtendInfo.sOptionData" :maxlength="2000" :placeholder="jsonDemo"></td-input>
                    <td-select
                        v-show="radio"
                        v-model="formExtendInfo.sTag"
                        :placeholder="$t('common.PLEASE_SELECT')"
                        @change="dictTagChange"
                        :options="this.dictDataList"
                        keys="sTag"
                        text="sTag"
                        :clearable="true"
                    >
                    </td-select>
                </el-form-item>
                <el-form-item v-show="!radio"> {{ $t('extendCommon.RULE_TIPS') }}</el-form-item>
            </el-row>
            <!-- <el-row v-show="showParamsSelect">
                <el-col :span="24">
                    <el-form-item :label="$t('common.EXTENDDATA')">
                        <td-select v-model="formExtendInfo.sOptionData" :placeholder="$t('common.PLEASE_SELECT')" :options="this.inputTypes" keys="key" text="label" :clearable="true"> </td-select>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('extendCommon.RULES')">
                        <td-select
                            v-model="formExtendInfo.sRegex"
                            :placeholder="$t('common.PLEASE_SELECT')"
                            @change="dictTagChange"
                            @blur="selectBlur"
                            :options="this.regexList"
                            keys="sRegex"
                            text="sName"
                            :clearable="true"
                        >
                        </td-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('extendCommon.TIPS_INFO')">
                        <td-input v-model="formExtendInfo.sRegexInfo" :maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formExtendInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click.native="extendDialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogExtendVisible', 'editItem', 'isAddData'],
    created() {
        resourceApi.getRegexList('', response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message.error({ showClose: true, message: response.data.statusMessage });
                this.$log.error('extend/getRegexList', response.data.statusMessage);
                return;
            }
            this.regexList = response.data.content;
        });

        resourceApi.getDictTypeList('', response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message.error({ showClose: true, message: response.data.statusMessage });
                this.$log.error('dict/getDictTypeList', response.data.statusMessage);
                return;
            }
            this.dictDataList = response.data.content;
        });

        resourceApi.getElementTypeList('', response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message.error({ showClose: true, message: response.data.statusMessage });
                this.$log.error('extend/getElementTypeList', response.data.statusMessage);
                return;
            }
            this.extendTypes = response.data.content;
            // this.formExtendInfo.sElementType = 'TdInput';
        });
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        }
    },
    // 定义变量
    data() {
        let validateElementFlg = (rule, value, callback) => {
            if (this.isAddData) {
                let reg = new RegExp(this.$regex.PASSWORD_RULE);
                if (!reg.test(value)) {
                    callback(this.$t('extendRegex.ONLY_NUMBERS_AND_LETTERS_ARE_ALLOWED'));
                }
            }
            let sId = '';
            if (!this.isAddData) {
                sId = this.formExtendInfo.sId;
            }
            let param = {
                sId: sId,
                sElementFlg: this.formExtendInfo.sElementFlg
            };
            resourceApi.checkElementFlg(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/checkElementFlg', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('extendError.ERROR_ELEMENT_FLG_EXIST'));
                } else {
                    callback();
                }
            });
        };
        //判断是否是JSON结构字符串
        let isJsonString = (rule, value, callback) => {
            try {
                //如果是字典表不校验json格式
                if (this.radio) {
                    callback();
                }
                if (!this.$util.isEmpty(value)) {
                    let obj = JSON.parse(value);
                    if (typeof obj == 'object' && obj) {
                        callback();
                    } else {
                        callback(this.$t('extendError.ERROR_JSON_FORMAT'));
                    }
                }
                callback();
            } catch (err) {
                callback(this.$t('extendError.ERROR_JSON_FORMAT'));
            }
        };
        return {
            regexList: [],
            dictDataList: [],
            jsonDemo: '[{"value": "option1","label": "option1"}]',
            extendTypes: [],
            inputTypes: [
                {
                    key: 'input',
                    label: this.$t('common.INPUT')
                },
                {
                    key: 'textarea',
                    label: this.$t('common.TEXTAREA')
                },
                {
                    key: 'password',
                    label: this.$t('common.PASSWORD_INPUT')
                }
            ],
            radio: false,
            optionsRadio: [
                { value: false, label: this.$t('extendCommon.MANUAL_INPUT') },
                { value: true, label: this.$t('extendCommon.DICT') }
            ],
            // Extend表单信息
            formExtendInfo: {
                sId: '',
                sName: '',
                sViewName: '',
                sElementFlg: '',
                sElementType: '',
                sOptionData: '',
                sTag: '',
                sRegex: '',
                sRegexInfo: ''
            },
            formLabelWidth: '85px',
            showParamsText: false,
            // showParamsSelect: false,
            loading: false,
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('extendError.ERROR_PLEASE_INPUT_EXTEND_NAME'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    {
                        pattern: this.$regex.CAPTION_RULE,
                        message: this.$t('error.ERROR_CAPTION_ILLEGAL')
                    }
                ],
                sElementFlg: [
                    { required: true, message: this.$t('extendError.ERROR_PLEASE_INPUT_ELEMENT_FLG'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { validator: validateElementFlg, trigger: 'blur' }
                ],
                sElementType: [{ required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'change' }],
                sOptionData: [{ validator: isJsonString, trigger: 'blur' }]
            }
        };
    },

    // 定义并实现方法体
    methods: {
        //校验规则可编辑
        selectBlur(e) {
            this.formExtendInfo.sRegex = e.target.value;
        },
        // 初始化编辑数据
        initEditData() {
            this.formExtendInfo.sId = this.editItem.sId;
            this.formExtendInfo.sName = this.editItem.sName;
            this.formExtendInfo.sViewName = this.editItem.sViewName;
            this.formExtendInfo.sElementFlg = this.editItem.sElementFlg;
            this.formExtendInfo.sElementType = this.editItem.sElementType;
            this.formExtendInfo.sOptionData = this.editItem.sOptionData;
            this.formExtendInfo.sRegex = this.editItem.sRegex;
            this.formExtendInfo.sRegexInfo = this.editItem.sRegexInfo;

            if (this.editItem.iDataSource == 1) {
                this.radio = true;
                this.formExtendInfo.sTag = this.editItem.sOptionData;
            }

            if (
                this.formExtendInfo.sElementType === 'TdSelect' ||
                this.formExtendInfo.sElementType === 'TdCheckboxGroup' ||
                this.formExtendInfo.sElementType === 'TdRadio' ||
                this.formExtendInfo.sElementType === 'TdTree' ||
                this.formExtendInfo.sElementType === 'TdTreeSelect'
            ) {
                this.showParamsText = true;
                // this.showParamsSelect = false;
            }
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                // console.log(formName)
                // return
                if (valid) {
                    // this.loading = true;
                    //数据类型 0 手动录入 1 字典表
                    let dataSource = 0;
                    let optionData = this.formExtendInfo.sOptionData;
                    if (this.radio) {
                        dataSource = 1;
                        optionData = this.formExtendInfo.sTag;
                    }

                    let content = {
                        sName: this.formExtendInfo.sName,
                        sViewName: this.formExtendInfo.sViewName,
                        sElementType: this.formExtendInfo.sElementType,
                        sElementFlg: this.formExtendInfo.sElementFlg,
                        iDataSource: dataSource,
                        sOptionData: optionData,
                        sRegex: this.formExtendInfo.sRegex,
                        sRegexInfo: this.formExtendInfo.sRegexInfo
                    };
                    let successMsg = this.$t('common.ADD_SUCCESS');
                    if (!this.isAddData) {
                        content.sId = this.editItem.sId;
                        successMsg = this.$t('common.MODIFY_SUCCESS');

                        resourceApi.updateExtendElement(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message.error({ showClose: true, message: response.data.statusMessage });
                                this.$log.error('extendManage/updateExtendElement', response.data.statusMessage);
                                return;
                            }
                            this.$message.success({ showClose: true, message: successMsg });
                            this.extendDialogClose();
                            this.$emit('submit');
                        });
                    } else {
                        resourceApi.insertExtendElement(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message.error({ showClose: true, message: response.data.statusMessage });
                                this.$log.error('extendManage/insertExtendElement', response.data.statusMessage);
                                return;
                            }
                            this.$message.success({ showClose: true, message: successMsg });
                            this.extendDialogClose();
                            this.$emit('submit');
                        });
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        extendDialogClose() {
            this.$emit('extendDialogClose');
            this.$refs['formExtendInfo'].resetFields(); // 重置表单数据
        },

        handleSelectChange(val) {
            this.formExtendInfo.sParam = '';
            if (val === 'TdSelect' || val === 'TdCheckboxGroup' || val === 'TdRadio' || val === 'TdTreeSelect' || val === 'TdTree') {
                this.showParamsText = true;
                // this.showParamsSelect = false;
            } else {
                this.showParamsText = false;
                // this.showParamsSelect = false;
            }
        },
        dictTagChange(val) {
            if (null == val || '' == val) {
                return;
            }
            let param = {
                sTag: val
            };
            resourceApi.getDictValuesByType(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message.error({ showClose: true, message: response.data.statusMessage });
                    this.$log.error('setting/getDictValuesByType', response.data.statusMessage);
                    return;
                }
                let res = response.data.content;
                let options = [];
                for (let index = 0; index < res.length; index++) {
                    const element = res[index];
                    options.push({ value: element.value, label: element.label });
                }
                this.formExtendInfo.sOptionData = JSON.stringify(options);
            });
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
